/** Mosque amenity flags — must match backend Mosque model boolean fields. */
export const MOSQUE_FEATURES = [
  { key: 'has_women_section', label: 'Women Section', defaultEnabled: true },
  { key: 'has_parking', label: 'Parking', defaultEnabled: false },
  { key: 'has_air_conditioning', label: 'Air Conditioning', defaultEnabled: false },
  { key: 'has_speaker_system', label: 'Speaker System', defaultEnabled: true },
  { key: 'has_wifi', label: 'WiFi', defaultEnabled: false },
  { key: 'has_ablution_area', label: 'Ablution Area', defaultEnabled: false },
  { key: 'has_library', label: 'Library', defaultEnabled: false },
];

export const MOSQUE_FEATURE_KEYS = MOSQUE_FEATURES.map((f) => f.key);

export const MOSQUE_BOOLEAN_FORM_KEYS = new Set(['is_public', ...MOSQUE_FEATURE_KEYS]);

export const defaultMosqueFeatureValues = () =>
  MOSQUE_FEATURES.reduce((acc, { key, defaultEnabled }) => {
    acc[key] = defaultEnabled;
    return acc;
  }, {});

/** Strip legacy extras appended to address (description, facilities, etc.). */
export const mosqueStreetAddressFromStored = (stored) => {
  if (!stored || typeof stored !== 'string') return '';
  const idx = stored.indexOf(' — ');
  return (idx >= 0 ? stored.slice(0, idx) : stored).trim();
};

export const featureValuesFromMosque = (mosque) =>
  MOSQUE_FEATURES.reduce((acc, { key, defaultEnabled }) => {
    if (mosque && mosque[key] !== undefined && mosque[key] !== null) {
      acc[key] = !!mosque[key];
    } else {
      acc[key] = defaultEnabled;
    }
    return acc;
  }, {});
